<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  export let request_store_key: StoresKey;

  const { nav_menus, site_page, reverse_router, i18nOf, locale } =
    getStoresContext(request_store_key);

  let rest: NavigationMenuItem[];
  let current: string = $site_page?.friendlyUrlPath;

  $: primary = $nav_menus.find((nav) => nav.navigationType == "Primary");
  $: submenu = primary
    ? primary.navigationMenuItems.find((nav) => nav.link == current)
    : [];
  $: [...rest] = submenu ? submenu.navigationMenuItems : [];
</script>

<div class="container-fluid container-fluid-max-xl">
  <div class="row">
    {#each rest.filter((item) => !item.excluded_locales?.some((x) => x == $locale)) as item}
      <li class="col-sm-12 col-md-6">
        {#if item.type == "url"}
          {#if item.availableLanguages.includes($locale)}
            <a class="col-12 sub-nav-item" href={item.url} target="_blank">
              <div>{i18nOf(item.name_i18n)}</div>
              <i
                style="transform: rotate(45deg); margin-left: 10px;"
                class="fa fa-arrow-up" />
            </a>
          {/if}
        {:else}
          <a
            class="col-12 sub-nav-item"
            href={$reverse_router.routePage(item.link)}>
            <div>{i18nOf(item.name_i18n)}</div>
            <i
              style="transform: rotate(45deg); margin-left: 10px;"
              class="fa fa-arrow-up" />
          </a>
        {/if}
      </li>
    {/each}
  </div>
</div>

<style lang="scss">
  .sub-nav-item {
    display: flex;
    flex-direction: row;
    font-style: normal;
    font-weight: 500;
    font-size: 2em;
    line-height: 130%;
    color: var(--color-black) !important;
    border-bottom: 1px solid var(--color-black);
    padding: 0 0 32px 0;
    margin: 60px 0 60px 0;
    cursor: pointer;
    &:hover {
      text-decoration: none !important;
      border-bottom: 1px solid var(--brandColor3);
      .fa-arrow-up {
        color: var(--brandColor3);
      }
    }
  }
  li {
    list-style: none;
  }
</style>
